import { Button, Dropdown, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import { formatDate, StatusBadge } from "./common";

export const TABLE_ACTION_MENU_POPPER_CONFIG = {
  strategy: "fixed",
};

export default function SurveyTable({
  items,
  busyId = null,
  onAction,
  compact = false,
}) {
  return (
    <div className="table-responsive">
      <Table className="fera-table fera-survey-table" hover>
        <thead>
          <tr>
            <th>Survey</th>
            <th>Status</th>
            {!compact ? <th>Responses</th> : null}
            {!compact ? <th>Version</th> : null}
            <th>Updated</th>
            <th><span className="visually-hidden">Actions</span></th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => {
            const busy = busyId === item.uuid;
            return (
              <tr key={item.uuid}>
                <td>
                  <Link className="fera-table-title" to={`/dashboard/surveys/${item.uuid}`}>
                    {item.name}
                  </Link>
                  {item.description ? <small>{item.description}</small> : null}
                </td>
                <td><StatusBadge status={item.status} /></td>
                {!compact ? <td>{item.responseCount ?? "\u2014"}</td> : null}
                {!compact ? <td>v{item.schemaVersion || 1}</td> : null}
                <td>{formatDate(item.updatedAt)}</td>
                <td className="text-end">
                  {onAction ? (
                    <div className="fera-row-actions">
                      {["draft", "closed"].includes(item.status) ? (
                        <Button
                          size="sm"
                          disabled={busy}
                          onClick={() => onAction(item, "publish")}
                        >
                          {item.status === "closed" ? "Reopen" : "Publish"}
                        </Button>
                      ) : null}
                      {item.status === "published" ? (
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          disabled={busy}
                          onClick={() => onAction(item, "close")}
                        >
                          Close
                        </Button>
                      ) : null}
                      <Button
                        as={Link}
                        size="sm"
                        variant="outline-primary"
                        to={`/dashboard/surveys/${item.uuid}`}
                      >
                        Properties
                      </Button>
                      <Dropdown align="end">
                        <Dropdown.Toggle
                          size="sm"
                          variant="outline-secondary"
                          disabled={busy}
                          aria-label={`More actions for ${item.name}`}
                        >
                          More
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="fera-table-action-menu"
                          popperConfig={TABLE_ACTION_MENU_POPPER_CONFIG}
                          renderOnMount
                        >
                          {["draft", "closed"].includes(item.status) ? (
                            <Dropdown.Item as={Link} to={`/dashboard/surveys/${item.uuid}/edit`}>Edit questions</Dropdown.Item>
                          ) : null}
                          <Dropdown.Item as={Link} to={`/dashboard/surveys/${item.uuid}/preview`}>Preview</Dropdown.Item>
                          <Dropdown.Item as={Link} to={`/dashboard/surveys/${item.uuid}/results`}>View results</Dropdown.Item>
                          <Dropdown.Item as={Link} to={`/dashboard/surveys/${item.uuid}/report`}>Aggregate report</Dropdown.Item>
                          {item.status === "published" ? (
                            <Dropdown.Item as={Link} to={`/dashboard/invitations?survey=${item.uuid}`}>Send invitations</Dropdown.Item>
                          ) : null}
                          {item.status !== "deleted" ? (
                            <Dropdown.Item onClick={() => onAction(item, "duplicate")}>Duplicate as draft</Dropdown.Item>
                          ) : null}
                          {!["archived", "deleted"].includes(item.status) ? (
                            <Dropdown.Item onClick={() => onAction(item, "archive")}>Archive</Dropdown.Item>
                          ) : null}
                          {item.status === "deleted" ? (
                            <Dropdown.Item onClick={() => onAction(item, "restore")}>Restore as closed</Dropdown.Item>
                          ) : (
                            <Dropdown.Item className="text-danger" onClick={() => onAction(item, "delete")}>Delete</Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  ) : (
                    <Button
                      as={Link}
                      size="sm"
                      variant="outline-primary"
                      to={`/dashboard/surveys/${item.uuid}`}
                    >
                      Open
                    </Button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
